<ng-container *ngIf="$servicingAORPhone | async as servicingAORPhone">
  <p-button label="Call" icon="pi pi-phone" (onClick)="makeCall(servicingAORPhone)" />
</ng-container>